/**
 * LIVE TELEMETRY STRIP & CONTROLS // KEVIN ARTHUR DE LIMA
 * Displays real-time deterministic metrics tied to scroll and flight mode.
 */

export function initTelemetry(config, onToggleWireframe) {
  const container = document.getElementById('telemetry-strip');
  if (!container) return null;

  container.innerHTML = `
    <div class="telemetry-left">
      <div class="telemetry-item">
        <span class="label">MODE:</span>
        <span class="val" id="telem-mode">${config.telemetry.baseMode}</span>
      </div>
      <div class="telemetry-item">
        <span class="label">RPM:</span>
        <span class="val" id="telem-rpm">0</span>
      </div>
      <div class="telemetry-item">
        <span class="label">ALT:</span>
        <span class="val" id="telem-alt">0.0 m</span>
      </div>
      <div class="telemetry-item">
        <span class="label">BAT:</span>
        <span class="val">${config.telemetry.battery} (${config.telemetry.voltage}V)</span>
      </div>
      <div class="telemetry-item">
        <span class="label">LOC:</span>
        <span class="val">${config.telemetry.station}</span>
      </div>
    </div>
    <div class="telemetry-right">
      <button class="telemetry-btn" id="telem-toggle-btn">[ TOGGLE: SOLID / WIREFRAME ]</button>
    </div>
  `;

  const elMode = document.getElementById('telem-mode');
  const elRpm = document.getElementById('telem-rpm');
  const elAlt = document.getElementById('telem-alt');
  const toggleBtn = document.getElementById('telem-toggle-btn');

  if (toggleBtn && onToggleWireframe) {
    toggleBtn.addEventListener('click', () => {
      const newMode = onToggleWireframe();
      toggleBtn.textContent = `[ VIEW: ${newMode} ]`;
    });
  }

  return function updateTelemetry(data) {
    if (elRpm) elRpm.textContent = data.rpm;
    if (elMode) elMode.textContent = data.mode;
    if (elAlt) elAlt.textContent = `${data.alt} m`;
  };
}
